import React from 'react';

const CartButton = ({ handleClick, open, itemCount }) => {
  return (
    <button type="button" className="Button Button--minicartToggle" data-style="noLayout" onClick={() => handleClick(!open)}>
      <span>Bag</span>
      <svg viewBox="0 0 20 20" className="icon icon--primary" width="1em" height="1em" aria-controls="miniCartDrawer" aria-haspopup="true">
        <use href="#cart"></use>
      </svg>
      {itemCount > 0 && <span className="count">{itemCount}</span>}

    </button>
  );
};

export default CartButton;
